import { useSearchParams } from "react-router-dom";
import InquiryForm from "@/components/InquiryForm";

export default function PlanVisit() {
  const [params] = useSearchParams();
  const presetPackageId = params.get("package");

  return (
    <div data-testid="plan-visit-page" className="pt-32 md:pt-40">
      <section className="mx-auto max-w-[1200px] px-6 md:px-12">
        <span className="overline text-primary">Concierge Design</span>
        <h1 className="mt-6 max-w-4xl font-serif text-5xl leading-[1.02] tracking-tight md:text-8xl">
          Compose your <em className="italic text-primary">Simhastha</em>.
        </h1>
        <p className="mt-10 max-w-2xl font-sans-lux text-lg leading-relaxed text-foreground/75">
          A brief conversation, then quiet work behind the scenes. Share the outline of your intent —
          dates, party, sensibilities — and we will return within 24 hours with a considered proposal.
        </p>
      </section>

      <section className="mx-auto max-w-[1200px] px-6 py-24 md:px-12 md:py-32">
        <InquiryForm presetPackageId={presetPackageId} />
      </section>

      <section className="border-t hairline bg-black py-24 md:py-32">
        <div className="mx-auto max-w-[1200px] px-6 md:px-12">
          <div className="grid gap-14 md:grid-cols-3">
            {[
              { k: "01", t: "Discreet", d: "Every conversation is private. Nothing is shared beyond our senior team." },
              { k: "02", t: "Personal", d: "One concierge remains with you from first note to the final aarti." },
              { k: "03", t: "Considered", d: "Slow, careful design. We would rather compose one journey well than many indifferently." },
            ].map((s) => (
              <div key={s.k}>
                <div className="font-serif text-4xl text-primary">{s.k}</div>
                <h3 className="mt-4 font-serif text-2xl">{s.t}</h3>
                <p className="mt-3 font-sans-lux text-foreground/70">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
